<template>
  <div class="vl-main">
    <!-- 顶部 -->
    <Header :headOpacityFit="headOpacityFit" />
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import {indexData} from "../../api/gxHome/api.home";
export default {
  name: "gx",
  components: { Header, Footer },
  data() {
    return {
      headOpacityFit: {
        max: 144, // 当滚动达到max值以上是透明度为1
        curOpacity: 0, // 当前透明度
      } /*----头部透明度自适应调整----*/,
    };
  },
  watch: {
    $route(n, o) {
      document.querySelector(".vl-main").scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  mounted() {
    // document.querySelector('.vl-main').style.overflowY = 'scroll';
    document.querySelector('.vl-main').scrollTo(0, 0);
    window.addEventListener("scroll", this.todoHeaderFit);
    this.getGlobalData();
  },
  methods: {
    getGlobalData() {
      indexData().then(res => {
        if (res.result) {
          this.$store.commit("setGlobalData", res.result);
        }
      })
    },
    todoHeaderFit() {
      let stPercent =
        document.documentElement.scrollTop / this.headOpacityFit.max;
      this.headOpacityFit.curOpacity =
        stPercent <= 0 ? 0 : stPercent > 1 ? 1 : stPercent;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/reset.scss";
#fx {
  transform-origin: top;
}
.vl-main{
  min-width: 1200px;
}
</style>
